import {
  RBAC_FNB_DASHBOARD_SPA,
  RBAC_TYPE_DASHBOARD_ACCOMODATION,
  RBAC_TYPE_DASHBOARD_IRD,
  RBAC_TYPE_DASHBOARD_RESTAURANT,
  RBAC_TYPE_DASHBOARD_SERVICE_REQUEST,
  RBAC_TYPE_DASHBOARD_SPA,
} from './RoleConsts';

export const OCCUPANCY = 'Occupancy';
export const IN_ROOM_DINING = 'In-Room Dining';
export const FNB_ORDERS = 'IRD';
export const FNB_BILL = 'F&B Bill';
export const SPA = 'Spa';
export const RESTAURANT = 'Restaurant';
export const HOUSEKEEPING = 'Housekeeping';
export const TABLE_RESERVATION = 'Restaurants';

export const DASHBOARD_IRD_VIEW = 'DASHBOARD_IRD_VIEW';
export const DASHBOARD_BILL_VIEW = 'DASHBOARD_BILL_VIEW';
export const DASHBOARD_SPA_VIEW = 'DASHBOARD_SPA_VIEW';
export const DASHBOARD_SPA_APPOINTMENTS_VIEW = 'DASHBOARD_SPA_APPOINTMENTS_VIEW';

export const REST_RESERVATION_CREATE = 'rest_reservation_create';
export const REST_RESERVATION_VIEW = 'rest_reservation_view';
export const REST_RESERVATION_EDIT = 'rest_reservation_edit';

export const HOUSEKEEPING_VIEW = 'HOUSEKEEPING_VIEW';

// date format
export const DATE_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATE_FORMAT_ISO = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'Do MMM';

//images
export const HOUSEKEEPING_IMAGE = '/assets/img/house-keeping.png';
export const NO_TABLE = '/assets/img/dashboard/no-table.png';
export const HOUSEKEEPING_SELECTED_IMAGE = '/assets/img/dashboard/housekeeping-selected.png';

export const DASHBOARD_ACTIVITY = [
  {
    name: OCCUPANCY,
    icon: 'king_bed',
    isActive: false,
    permission: RBAC_TYPE_DASHBOARD_ACCOMODATION,
  },
  {
    name: FNB_ORDERS,
    icon: 'restaurant',
    isActive: false,
    permission: RBAC_TYPE_DASHBOARD_IRD,
  },
  {
    name: SPA,
    icon: 'spa',
    isActive: false,
    permission: RBAC_TYPE_DASHBOARD_SPA,
  },
  {
    name: TABLE_RESERVATION,
    icon: 'fastfood',
    isActive: false,
    permission: RBAC_TYPE_DASHBOARD_RESTAURANT,
  },
  {
    name: HOUSEKEEPING,
    icon: HOUSEKEEPING_IMAGE,
    isActive: false,
    iconType: 'image',
    iconSelected: HOUSEKEEPING_SELECTED_IMAGE,
    permission: RBAC_TYPE_DASHBOARD_SERVICE_REQUEST,
  },
];

export const IN_ROOM_DINING_COUNT = [
  {
    icon: './assets/icons/dashboard/room-service-black.svg',
    color: '#C5F9E9',
    count: '00',
    countColor: '#1AA27B',
    name: 'Total Orders Received',
    status: 'TOTAL',
  },
  {
    icon: './assets/icons/dashboard/login-black.svg',
    color: '#F7B538',
    count: '00',
    countColor: '#F7B538',
    name: 'New Orders',
    status: 'NEW_ORDER',
  },
  {
    icon: './assets/icons/dashboard/cooking.svg',
    color: '#DBEAFE',
    count: '00',
    countColor: '#2F7BEC',
    name: 'Preparing',
    status: 'PREPARING',
  },
  {
    icon: './assets/icons/dashboard/pending-actions.svg',
    color: '#FFD8E0',
    count: '00',
    countColor: '#E04667',
    name: 'Delayed Orders',
    status: 'DELAYED',
  },
  {
    icon: './assets/icons/dashboard/check-box-black.svg',
    color: '#1AA27B',
    count: '00',
    countColor: '#1AA27B',
    name: 'Completed',
    status: 'COMPLETED',
  },
];

export const IRD_STATUS = [
  { id: 'New Order', name: 'New Order', selected: false },
  { id: 'Preparing', name: 'Preparing', selected: false },
  { id: 'Delayed', name: 'Delayed', selected: false },
  { id: 'Completed', name: 'Completed', selected: false },
];

export const FNB_STATUS = [
  { id: 'New Order', name: 'New Order', selected: false },
  { id: 'Preparing', name: 'Preparing', selected: false },
  { id: 'Declined', name: 'Declined', selected: false },
  { id: 'Delivered', name: 'Delivered', selected: false },
  { id: 'Bill Requested', name: 'Bill Requested', selected: false },
  { id: 'Paid', name: 'Paid', selected: false },
];

export const FNB_BILL_STATUS = [
  { id: 'Bill Requested', name: 'Bill Requested', selected: false },
  { id: 'Paid', name: 'Paid', selected: false },
];

export const IRD_FILTER = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Status',
    field: 'status',
    subMenu: IRD_STATUS,
  },
];

export const FNB_ORDERS_COUNT = [
  {
    icon: './assets/icons/dashboard/room-service-black.svg',
    color: '#C5F9E9',
    count: '00',
    countColor: '#1AA27B',
    name: 'Total Orders Received',
    status: 'TOTAL',
  },
  {
    icon: './assets/icons/dashboard/login-black.svg',
    color: '#F7B538',
    count: '00',
    countColor: '#F7B538',
    name: 'New Orders',
    status: 'NEW_ORDER',
  },
  {
    icon: './assets/icons/dashboard/cooking.svg',
    color: '#DBEAFE',
    count: '00',
    countColor: '#2F7BEC',
    name: 'Preparing',
    status: 'PREPARING',
  },
  {
    icon: './assets/icons/dashboard/check-box-black.svg',
    color: '#1AA27B',
    count: '00',
    countColor: '#1AA27B',
    name: 'Delivered',
    status: 'DELIVERED',
  },
  {
    icon: './assets/icons/dashboard/receipt_long_black_24dp.svg',
    color: '#1A86A2',
    count: '00',
    countColor: '#1A86A2',
    name: 'Bill Requests',
    status: 'BILL_REQUESTED',
  },
];

export const FNB_SORTING_ORDER = [
  'NEW_ORDER',
  'PREPARING',
  'DECLINED',
  'DELIVERED',
  'BILL_REQUESTED',
  'PAID',
];

export const SPA_STATUS_NEW_REQUEST = 'NEW_REQUEST';
export const SPA_STATUS_ACCEPTED = 'ACCEPTED';
export const SPA_STATUS_ARRIVING_TODAY = 'ARRIVING_TODAY';
export const SPA_STATUS_SCHEDULED = 'SCHEDULED';
export const SPA_STATUS_DECLINED = 'DECLINED';
export const SPA_STATUS_GUEST_DECLINED = 'GUEST_DECLINED';
export const SPA_STATUS_COMPLETED = 'COMPLETED';

export const SPA_COUNTBOX_LIST = [
  {
    icon: './assets/icons/dashboard/booking_spa.svg',
    color: '#C5F9E9',
    count: '00',
    countColor: '#1AA27B',
    name: 'Total Bookings',
    status: 'ALL',
  },
  {
    icon: './assets/icons/dashboard/room_service_black_spa.svg',
    color: '#F7B538',
    count: '00',
    countColor: '#F7B538',
    name: 'New Requests',
    status: SPA_STATUS_NEW_REQUEST,
  },
  {
    icon: './assets/icons/dashboard/login_black_spa.svg',
    color: '#DBEAFE',
    count: '00',
    countColor: '#2F7BEC',
    name: "Today's Arrivals",
    status: SPA_STATUS_ARRIVING_TODAY,
  },
  {
    icon: './assets/icons/dashboard/timetable_spa.svg',
    color: '#2F7BEC',
    count: '00',
    countColor: '#2F7BEC',
    name: 'Scheduled',
    status: SPA_STATUS_SCHEDULED,
  },
  {
    icon: './assets/icons/dashboard/cancel_spa.svg',
    color: '#828282',
    count: '00',
    countColor: '#828282',
    name: 'Booking cancelled',
    status: SPA_STATUS_GUEST_DECLINED,
  },
  {
    icon: './assets/icons/dashboard/check_box_black_spa.svg',
    color: '#1AA27B',
    count: '00',
    countColor: '#1AA27B',
    name: 'Completed',
    status: SPA_STATUS_COMPLETED,
  },
];

export const SPA_STATUS = [
  { id: 'New Request', name: 'New Request', selected: false },
  { id: 'Arriving Today', name: 'Arriving Today', selected: false },
  { id: 'Scheduled', name: 'Scheduled', selected: false },
  { id: 'Completed', name: 'Completed', selected: false },
  { id: 'Declined', name: 'Declined', selected: false },
  { id: 'Cancelled', name: 'Cancelled', selected: false },
];

export const SPA_FILTER = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Status',
    field: 'status',
    subMenu: SPA_STATUS,
  },
];

export const SPA_SORTING_ORDER = [
  SPA_STATUS_NEW_REQUEST,
  SPA_STATUS_ARRIVING_TODAY,
  SPA_STATUS_SCHEDULED,
  SPA_STATUS_COMPLETED,
  SPA_STATUS_DECLINED,
  SPA_STATUS_GUEST_DECLINED,
];

export const SPA_STATUS_DROPDOWN = [
  { id: 'All', name: 'All' },
  { id: 'New Request', name: 'New Requests' },
  { id: 'Scheduled', name: 'Scheduled' },
  { id: 'Completed', name: 'Completed' },
];

export const ALL_STATUS_COLOR = [
  { id: 'New Request', color: '#F7B538', backGroundColor: '#FFFFFF' },
  { id: 'Scheduled', color: '#2F7BEC', backGroundColor: '#E7F6FC' },
  { id: 'Completed', color: '#1AA27B', backGroundColor: '#D0F7E2' },
  { id: 'Arriving Today', color: '#DBEAFE', backGroundColor: '#E7F6FC' },
  { id: 'Declined', color: '#E04667', backGroundColor: '' },
  { id: 'Cancelled', color: '#828282', backGroundColor: '' },
];

export const CALENDAR_VIEW = [
  { id: 'timeGridDay', name: 'Day View' },
  { id: 'timeGridWeek', name: 'Week View' },
  { id: 'dayGridMonth', name: 'Month View' },
];

export const REST_STATUS_NEW_REQUEST = 'NEW_REQUEST'; //info:Backend response is coming as NEW_REQUEST
export const REST_STATUS_SCHEDULED = 'Scheduled';
export const REST_STATUS_ARRIVING_TODAY = 'Arriving Today';
export const REST_STATUS_NO_SHOWS = 'NoShow';
export const REST_STATUS_DECLINED = 'Declined';
export const REST_STATUS_GUEST_CANCELLED = 'Cancelled';
export const REST_STATUS_COMPLETED = 'Completed';

export const REST_SORTING_ORDER = [
  REST_STATUS_NEW_REQUEST,
  REST_STATUS_ARRIVING_TODAY,
  REST_STATUS_SCHEDULED,
  REST_STATUS_NO_SHOWS,
  REST_STATUS_GUEST_CANCELLED,
  REST_STATUS_DECLINED,
  REST_STATUS_COMPLETED,
];

export const REST_STATUS_DROPDOWN = [
  { id: 'All', name: 'All' },
  { id: 'New Request', name: 'New Requests' },
  { id: 'Scheduled', name: 'Scheduled' },
  { id: 'Completed', name: 'Completed' },
];

export const RESTAURANT_COUNTBOX_LIST = [
  {
    icon: './assets/icons/dashboard/booking_spa.svg',
    color: '#C5F9E9',
    count: '00',
    countColor: '#1AA27B',
    name: 'Total Reservations',
    status: 'ALL',
    showInLanding: true,
  },
  {
    icon: './assets/icons/dashboard/room_service_black_spa.svg',
    color: '#F7B538',
    count: '00',
    countColor: '#F7B538',
    name: 'New Requests',
    status: REST_STATUS_NEW_REQUEST,
    showInLanding: true,
  },
  {
    icon: './assets/icons/dashboard/login_black_spa.svg',
    color: '#DBEAFE',
    count: '00',
    countColor: '#2F7BEC',
    name: "Today's Arrivals",
    status: REST_STATUS_ARRIVING_TODAY,
    showInLanding: true,
  },
  {
    icon: './assets/icons/dashboard/no-show.svg',
    color: '#FFD8E0',
    count: '00',
    countColor: '#E04667',
    name: 'No Shows',
    status: REST_STATUS_NO_SHOWS,
    showInLanding: true,
  },
  {
    icon: './assets/icons/dashboard/thumb-down.svg',
    color: '#FFD8E0',
    count: '00',
    countColor: '#E04667',
    name: 'Request Declined',
    status: REST_STATUS_DECLINED,
    showInLanding: false,
  },
  {
    icon: './assets/icons/dashboard/cancel_spa.svg',
    color: '#828282',
    count: '00',
    countColor: '#828282',
    name: 'Booking cancelled',
    status: REST_STATUS_GUEST_CANCELLED,
    showInLanding: false,
  },
  {
    icon: './assets/icons/dashboard/check_box_black_spa.svg',
    color: '#1AA27B',
    count: '00',
    countColor: '#1AA27B',
    name: 'Completed',
    status: REST_STATUS_COMPLETED,
    showInLanding: false,
  },
];

export const REST_STATUS = [
  {
    id: 'New Request',
    name: 'New Request',
    selected: false,
    status: REST_STATUS_NEW_REQUEST,
  },
  {
    id: 'Arriving Today',
    name: 'Arriving Today',
    selected: false,
    status: REST_STATUS_ARRIVING_TODAY,
  },
  {
    id: 'Scheduled',
    name: 'Scheduled',
    selected: false,
    status: REST_STATUS_SCHEDULED,
  },
  {
    id: 'Completed',
    name: 'Completed',
    selected: false,
    status: REST_STATUS_COMPLETED,
  },
  {
    id: 'Declined',
    name: 'Declined',
    selected: false,
    status: REST_STATUS_DECLINED,
  },
  {
    id: 'NoShow',
    name: 'No Show',
    selected: false,
    status: REST_STATUS_NO_SHOWS,
  },
  {
    id: 'Cancelled',
    name: 'Cancelled',
    selected: false,
    status: REST_STATUS_GUEST_CANCELLED,
  },
];

export const REST_GUEST_TYPE = [
  { id: 'resident', name: 'Resident', selected: false },
  { id: 'nonResident', name: 'Non Resident', selected: false },
];

export const SREST_FILTER = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Guest Type',
    field: 'guestType',
    subMenu: REST_GUEST_TYPE,
  },
  {
    title: 'Status',
    field: 'status',
    subMenu: REST_STATUS,
  },
];

export const DASHBOARD_REST_VIEW = 'DASHBOARD_REST_VIEW';
export const DASHBOARD_REST_TABLES_VIEW = 'DASHBOARD_REST_TABLES_VIEW';
export const DASHBOARD_REST_RESERV_VIEW = 'DASHBOARD_REST_RESERV_VIEW';
export const DASHBOARD_REST_TABLES_INFO_VIEW = 'DASHBOARD_REST_TABLES_INFO_VIEW';
export const DASHBOARD_REST_TABLES_INFO_CREATE = 'DASHBOARD_REST_TABLES_INFO_CREATE';
export const DASHBOARD_REST_TABLES_INFO_DETAILS = 'DASHBOARD_REST_TABLES_INFO_DETAILS';

export const TIME = [
  '12 AM',
  '01 AM',
  '02 AM',
  '03 AM',
  '04 AM',
  '05 AM',
  '06 AM',
  '07 AM',
  '08 AM',
  '09 AM',
  '10 AM',
  '11 AM',
  '12 PM',
  '01 PM',
  '02 PM',
  '03 PM',
  '04 PM',
  '05 PM',
  '06 PM',
  '07 PM',
  '08 PM',
  '09 PM',
  '10 PM',
  '11 PM',
];

export const TABLE_STATUS_VACANT = 'Vacant';
export const TABLE_STATUS_RESERVED = 'Reserved';
export const TABLE_STATUS_OCCUPIED = 'Occupied';
export const TABLE_STATUS_NOBOOKINGS = 'No Bookings';
export const TABLE_STATUS_INACTIVE = 'Inactive';

export const RES_TABLE_STATUS = [
  { id: TABLE_STATUS_VACANT, name: TABLE_STATUS_VACANT, selected: false },
  { id: TABLE_STATUS_RESERVED, name: TABLE_STATUS_RESERVED, selected: false },
  { id: TABLE_STATUS_OCCUPIED, name: TABLE_STATUS_OCCUPIED, selected: false },
  { id: TABLE_STATUS_INACTIVE, name: TABLE_STATUS_INACTIVE, selected: false },
];

export const RES_TABLE_FILTER = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: TABLE_STATUS_NOBOOKINGS,
    field: TABLE_STATUS_NOBOOKINGS,
    subMenu: [],
  },
  {
    title: 'Status',
    field: 'status',
    subMenu: RES_TABLE_STATUS,
  },
];

export const TIME_LIST = [
  { id: '30', name: '30 min' },
  { id: '60', name: '60 min' },
  { id: '90', name: '90 min' },
  { id: '120', name: '120 min' },
];

export const WEEK_DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const HOUSEKEEPING_STATUS_NEW_REQUEST = 'NEW_REQUEST';
export const HOUSEKEEPING_STATUS_ASSIGN_REQUEST = 'ASSIGNED';
export const HOUSEKEEPING_STATUS_RESOLVED = 'RESOLVED';
export const HOUSEKEEPING_STATUS_ON_HOLD = 'ON_HOLD';

export const HOUSEKEEPING_COUNTBOX_LIST = [
  {
    icon: './assets/icons/dashboard/room-service-black.svg',
    color: '#C5F9E9',
    count: '00',
    countColor: '#1AA27B',
    name: 'Total Requests',
    status: 'ALL',
    showInLanding: true,
  },
  {
    icon: './assets/icons/dashboard/login-black.svg',
    color: '#F7B538',
    count: '00',
    countColor: '#F7B538',
    name: 'New Requests',
    status: HOUSEKEEPING_STATUS_NEW_REQUEST,
    showInLanding: true,
  },
  {
    icon: './assets/icons/dashboard/assignment_ind.svg',
    color: '#DBEAFE',
    count: '00',
    countColor: '#2F7BEC',
    name: 'Assigned Request',
    status: HOUSEKEEPING_STATUS_ASSIGN_REQUEST,
    showInLanding: true,
  },
  {
    icon: './assets/icons/dashboard/pause_circle.svg',
    color: '#2F7BEC',
    count: '00',
    countColor: '#2F7BEC',
    name: 'On Hold Requests',
    status: HOUSEKEEPING_STATUS_ON_HOLD,
    showInLanding: false,
  },
  {
    icon: './assets/icons/dashboard/check_box_black_spa.svg',
    color: '#1AA27B',
    count: '00',
    countColor: '#1AA27B',
    name: 'Resolved',
    status: HOUSEKEEPING_STATUS_RESOLVED,
    showInLanding: true,
  },
];

export const HOUSEKEEPING_STATUS = [
  {
    id: HOUSEKEEPING_STATUS_NEW_REQUEST,
    name: 'New Requests',
    selected: false,
  },
  {
    id: HOUSEKEEPING_STATUS_ASSIGN_REQUEST,
    name: 'Assigned Request',
    selected: false,
  },
  {
    id: HOUSEKEEPING_STATUS_ON_HOLD,
    name: 'On Hold Requests',
    selected: false,
  },
  { id: HOUSEKEEPING_STATUS_RESOLVED, name: 'Resolved', selected: false },
];

export const HOUSEKEEPING_TYPES = [
  { id: 'Room Request', name: 'Room Request', selected: false },
  { id: 'Concierge', name: 'Concierge', selected: false },
];

export const HOUSEKEEPING_SORTING_ORDER = [
  HOUSEKEEPING_STATUS_ASSIGN_REQUEST,
  REST_STATUS_ARRIVING_TODAY,
  HOUSEKEEPING_STATUS_ON_HOLD,
  HOUSEKEEPING_STATUS_RESOLVED,
];

export const HOUSEKEEPING_FILTER = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Status',
    field: 'status',
    subMenu: HOUSEKEEPING_STATUS,
  },
  {
    title: 'Type',
    field: 'requestType',
    subMenu: HOUSEKEEPING_TYPES,
  },
];

export const OCCUPANCY_COUNTBOX_LIST = [
  {
    icon: './assets/icons/dashboard/king_bed_black.svg',
    color: '#C5F9E9',
    count: '00',
    countColor: '#1AA27B',
    name: 'Current Occupancy',
  },
  {
    icon: './assets/icons/dashboard/smartphone_black.svg',
    color: '#F7B538',
    count: '00',
    countColor: '#F7B538',
    name: 'Digital Check-Ins',
  },
  {
    icon: './assets/icons/dashboard/vpn_key_black.svg',
    color: '#0B353F',
    count: '00',
    countColor: '#1AA27B',
    name: 'Digital Key Activated',
  },
  {
    icon: './assets/icons/dashboard/meeting_room_black.svg',
    color: '#F7B538',
    count: '00',
    countColor: '#1AA27B',
    name: 'Total Accommodation',
  },
  {
    icon: './assets/icons/dashboard/checkin.svg',
    color: '#202020',
    count: '00',
    countColor: '#202020',
    name: 'Check-In Today',
    unit: '',
    completedCount: '00',
    pendingCount: '00',
    type: 'status',
  },
  {
    icon: './assets/icons/dashboard/checkout.svg',
    color: '#F7B538',
    count: '00',
    countColor: '#202020',
    name: 'Check-Outs',
    unit: '',
    completedCount: '00',
    pendingCount: '00',
    type: 'status',
  },
];

export const OCCUPANCY_DETAIL_COUNTBOX_LIST = [
  {
    items: [
      {
        icon: './assets/icons/dashboard/king_bed_black.svg',
        color: '#0B353F',
        count: 0,
        countColor: '#1AA27B',
        name: 'Occupancy',
        unit: '',
        backGroundColor: '#0B353F',
        type: 'percentage',
        titleColor: '#FFF',
      },
      {
        icon: './assets/icons/dashboard/king_bed_black.svg',
        color: '#212529',
        count: '00',
        countColor: '#1AA27B',
        name: 'Current Occupancy',
        unit: 'Rooms',
        type: 'normal',
      },
      {
        icon: './assets/icons/dashboard/meeting_room_black.svg',
        color: '#212529',
        count: '00',
        countColor: '#1AA27B',
        name: 'Total Accommodation',
        unit: 'Rooms',
        type: 'normal',
      },
    ],
  },
  {
    items: [
      {
        icon: './assets/icons/dashboard/checkin.svg',
        color: '#202020',
        count: '00',
        countColor: '#202020',
        name: 'Check-In Today',
        unit: '',
        completedCount: '00',
        pendingCount: '00',
        type: 'status',
      },
      {
        icon: './assets/icons/dashboard/checkout.svg',
        color: '#F7B538',
        count: '00',
        countColor: '#202020',
        name: 'Check - Outs',
        unit: '',
        completedCount: '00',
        pendingCount: '00',
        type: 'status',
      },
    ],
  },
  {
    items: [
      {
        icon: './assets/icons/dashboard/smartphone_blue.svg',
        color: '#212529',
        count: '00',
        countColor: '#1AA27B',
        name: 'Digital Check-ins',
        unit: '',
        type: 'normal',
        className: 'extend',
      },
      {
        icon: './assets/icons/dashboard/vpn_key_black.svg',
        color: '#FFF',
        count: '00',
        countColor: '#1AA27B',
        backGroundColor: '#0B353F',
        name: 'Digital Keys Activated',
        unit: '',
        type: 'normal',
        className: 'extend',
      },
    ],
  },
];
